import api from './api';

export default {
  // ===== PLAYER BUFFS =====
  async getPlayerBuffs(playerId) {
    try {
      const response = await api.get(`/player-buffs/player/${playerId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching player buffs:', error);
      throw error;
    }
  },

  async applyPlayerBuff(playerId, effectType, effectValue, duration, source = 'manual') {
    try {
      const response = await api.post('/player-buffs/apply', {
        playerId,
        effectType,
        effectValue,
        duration,
        source
      });
      return response.data;
    } catch (error) {
      console.error('Error applying player buff:', error);
      throw error;
    }
  },

  // ===== PLAYER DEBUFFS =====
  async getPlayerDebuffs(playerId) {
    try {
      const response = await api.get(`/hospitals/debuffs/player/${playerId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching player debuffs:', error);
      throw error;
    }
  },

  async curePlayerDebuff(playerId, debuffId) {
    try {
      const response = await api.post('/hospitals/cure/player-debuff', {
        playerId,
        debuffId
      });
      return response.data;
    } catch (error) {
      console.error('Error curing player debuff:', error);
      throw error;
    }
  },

  // ===== FIGHTER BUFFS =====
  async getFighterBuffs(fighterId) {
    try {
      const response = await api.get(`/fighter-buffs/fighter/${fighterId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching fighter buffs:', error);
      throw error;
    }
  },

  async applyFighterBuff(fighterId, effectType, effectValue, duration, source = 'manual') {
    try {
      const response = await api.post('/fighter-buffs/apply', {
        fighterId,
        effectType,
        effectValue,
        duration,
        source
      });
      return response.data;
    } catch (error) {
      console.error('Error applying fighter buff:', error);
      throw error;
    }
  },

  async applyFoodBuff(fighterId, foodId) {
    try {
      const response = await api.post('/fighter-buffs/apply-food', {
        fighterId,
        foodId
      });
      return response.data;
    } catch (error) {
      console.error('Error applying food buff:', error);
      throw error;
    }
  },

  async getFighterBuffedStats(fighterId) {
    try {
      const response = await api.get(`/fighter-buffs/buffed-stats/${fighterId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting fighter buffed stats:', error);
      throw error;
    }
  },

  // ===== FIGHTER DEBUFFS =====
  async getFighterDebuffs(fighterId) {
    try {
      const response = await api.get(`/hospitals/debuffs/fighter/${fighterId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching fighter debuffs:', error);
      throw error;
    }
  },

  async cureFighterDebuff(playerId, fighterId, debuffId) {
    try {
      const response = await api.post('/hospitals/cure/fighter-debuff', {
        playerId,
        fighterId,
        debuffId
      });
      return response.data;
    } catch (error) {
      console.error('Error curing fighter debuff:', error);
      throw error;
    }
  },

  async getFighterDebuffedStats(fighterId) {
    try {
      const response = await api.get(`/fighter-debuffs/debuffed-stats/${fighterId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting fighter debuffed stats:', error);
      throw error;
    }
  },

  // ===== BATTLE DEBUFFS =====
  async applyBattleDebuff(fighterId, debuffType, severity = 1) {
    try {
      const response = await api.post('/fighter-debuffs/apply-battle', {
        fighterId,
        debuffType,
        severity
      });
      return response.data;
    } catch (error) {
      console.error('Error applying battle debuff:', error);
      throw error;
    }
  },

  // ===== BUSINESS DEBUFFS =====
  async applyBusinessDebuff(playerId, debuffType, severity = 1) {
    try {
      const response = await api.post('/player-debuffs/apply-business', {
        playerId,
        debuffType,
        severity
      });
      return response.data;
    } catch (error) {
      console.error('Error applying business debuff:', error);
      throw error;
    }
  },

  // ===== RESISTANCE CALCULATION =====
  async calculateFighterResistance(fighterId, debuffType) {
    try {
      const response = await api.get(`/fighter-debuffs/resistance/${fighterId}/${debuffType}`);
      return response.data;
    } catch (error) {
      console.error('Error calculating fighter resistance:', error);
      throw error;
    }
  },

  // ===== MULTIPLIERS =====
  async getPlayerDebuffMultipliers(playerId) {
    try {
      const response = await api.get(`/player-debuffs/multipliers/${playerId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting player debuff multipliers:', error);
      throw error;
    }
  },

  async getPlayerBuffMultipliers(playerId) {
    try {
      const response = await api.get(`/player-buffs/multipliers/${playerId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting player buff multipliers:', error);
      throw error;
    }
  }
};